var React = require('react');

function IconSuccessMessage (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#a)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M31.944 3.944v17.943c0 2.204-1.797 3.944-4 3.944h-9l-7.806 5.855a.755.755 0 0 1-1.195-.606v-5.249h-6c-2.204 0-4-1.797-4-3.944V3.944C-.057 1.74 1.739 0 3.943 0h24c2.257 0 4 1.797 4 3.944ZM8 10.5A1.5 1.5 0 0 1 9.5 9h13a1.5 1.5 0 0 1 0 3h-13A1.5 1.5 0 0 1 8 10.5ZM9.5 15a1.5 1.5 0 0 0 0 3h7a1.5 1.5 0 0 0 0-3h-7Z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fill":"#fff","d":"M0 0h32v32H0z"})))]);
}

IconSuccessMessage.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = IconSuccessMessage;

IconSuccessMessage.default = IconSuccessMessage;
